module.exports = __webpack_public_path__ + "img/earth-card.f4c3e0a.png";